<template>
  <div class="layout-main">
      <Card :dis-hover="true">
        <div class="search-panel">
          <ul class="list-group">
           
            <li class="list-group-item">
              <div class="item-label">搜索: </div>
              <Input v-model="searchval" style="width: 500px" >
                      <Select v-model="searchfield" slot="prepend" style="width: 80px">
                          <Option value="name">分组名</Option>
                      </Select>
                      <Button @click="request" slot="append" icon="ios-search"></Button>
                  </Input>
             
            </li>
          </ul>
        </div>
        <Divider style="margin: 0px;" dashed />
        <div style="padding: 10px 0px;" class="tools">
          <Button @click="groupAddModal = true" size="small" type="primary">添加</Button>
        </div>
        <Table :loading="loading" :columns="columns" :data="data" height="400">
          <template slot-scope="{ row }" slot="name">
              <strong>{{ row.name }}</strong>
          </template>
          <template slot-scope="{ row }" slot="msg">
              <Button @click="groupMsgModelShow(row)" size="small" type="primary">发送消息</Button>
          </template>          
          <template slot-scope="{ row }" slot="action">
              <Icon @click="groupEditModalShow(row)" style="cursor: pointer;" type="md-create" />
              <Icon @click="delGroup(row)" style="cursor: pointer;" type="md-trash" />
          </template>
        </Table>
        <div class="page-wrap">            
          <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
        </div>
      </Card>
       <Modal 
          v-model="groupAddModal"
          title="添加分组"
          :footer-hide="true"
          width="400"
          >
           <Form :model="groupAddForm" :label-width="80">
            <FormItem label="分组名">
                <Input v-model="groupAddForm.name" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入分组名"></Input>
            </FormItem>
            <FormItem>
                <Button @click="addGroup()" type="primary">添加</Button>
            </FormItem>
          </Form>
      </Modal>
      <Modal 
          v-model="groupEditModal"
          title="编辑分组"
          :footer-hide="true"
          width="400"
          >
           <Form :model="groupEditForm" :label-width="80">
            <FormItem label="分组名">
                <Input v-model="groupEditForm.name" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入分组名"></Input>
            </FormItem>
            <FormItem>
                <Button @click="editGroup()" type="primary">确定</Button>
            </FormItem>
          </Form>
      </Modal>
      <Modal 
          v-model="groupMsgModel"
          title="群发消息"
          :footer-hide="true"
          width="400"
          >
           <Form :model="groupMsgForm" :label-width="80">
            <FormItem label="群发消息">
              <Input v-model="groupMsgForm.content" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入群发内容"></Input>
            </FormItem>
            <FormItem>
                <Button @click="groupMsgSend()" type="primary">确定</Button>
            </FormItem>
          </Form>
      </Modal>
  </div>
</template>
<script>
import conf from "@/views/im/conf";
import RequestUtils from "@/utils/RequestUtils";

export default {
  
  data() {
    return {
      loading: false,
      groupAddModal: false,
      groupEditModal: false,
      groupMsgModel: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'name',
      searchval: '',
      filter: {
        name: ''
      },
      groupAddForm: {
        name: ''
      },
      groupMsgForm: {
        id: 0,
        content: ''
      },
      groupEditForm: {
        id: 0,
        name: ''
      },
      columns: [
          {
              title: '分组名',
              key: 'name'
          },
          {
              title: '买家数量',
              key: 'buyer_num'
          },
          {
              title: '群发消息',
              slot: 'msg'
          },
          {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },

  methods: {
    authorize () {
      let param = new FormData();
      param.set("appcate", 'IM');

      RequestUtils.request(conf.getAuthUrl(this.filter.connector), param)
      .then(data => {      
        window.open(data.url,"Add Account", "width=1024,height=600,toolbar=no,location=no,directories=no,status=no,menubar=yes,scrollbars=yes");
      })
    },
    selectitem (key, value) {
      this.filter[key] = value;
      this.request();
    },
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
    },
    buildparams () {
      let param = new FormData();
      param.set("page", this.curPage );
      param.set("name", this.filter.name);
      if (this.searchval) {
        param.set(this.searchfield, this.searchval);
      }
      
      return param;
    },
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.getSessionGroup(), self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.data;
        self.loading = false;
      })
    },
    addGroup() {
      let param = new FormData();
      param.set("name", this.groupAddForm.name );
      RequestUtils.request(conf.addSessionGroup(), param)
      .then(() => {            
        this.groupAddForm.name = '';
        this.groupAddModal = false;
        this.request();
      })
    },
    editGroup() {
      let param = new FormData();
      param.set("id", this.groupEditForm.id );
      param.set("name", this.groupEditForm.name );
      RequestUtils.request(conf.editSessionGroup(), param)
      .then(() => {            
        this.groupEditForm.name = '';
        this.groupEditModal = false;
        this.request();
      })
    },
    groupEditModalShow(row) {
      this.groupEditModal = true;

      this.groupEditForm.id = row.id;
      this.groupEditForm.name = row.name;
    },
    delGroup(row) {
      
      this.$Modal.confirm({
          title: '删除',
          content: '<p>确定删除该记录吗?</p>',
          onOk: () => {

            let param = new FormData();
            param.set("id", row.id );

            RequestUtils.request(conf.delSessionGroup(), param)
            .then(() => {            
                this.$Message.info('操作成功!');
                this.request();
            })
          },
          onCancel: () => {
          }
      });
    },
    groupMsgModelShow(row) {
      this.groupMsgModel = true;
      this.groupMsgForm.id = row.id;

    },
    groupMsgSend() {
      let param = new FormData();
      param.set("group_id", this.groupMsgForm.id );
      param.set("content", this.groupMsgForm.content );
      
      this.groupMsgModel = false;
      RequestUtils.request(conf.groupMsgSend(), param)
      .then(() => {            
        this.request();
      })
    }
    
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      margin-top: 4rem;
      padding: 1rem;
      
    }
  }

  
}
</style>
